module.exports = __webpack_public_path__ + "static/media/colgate pro_gum.0fbb3e35.gif";


//////////////////
// WEBPACK FOOTER
// ./src/img/colgate pro_gum.gif
// module id = 380
// module chunks = 0